export default {
  nav: {
    home: '首页',
    about: '关于我们',
    equipments: 'SLM 设备',
    products: '应用产品',
    factory: '工厂资质',
    projects: '案例展示',
    news: '新闻动态',
    contact: '联系我们',
  },
  footer: {
    quickLinks: '快速链接',
    company: '公司',
    contact: '联系方式',
    getInTouch: '联系我们',
    rights: '山东创瑞激光科技有限公司 版权所有',
  },
  home: {
    tagline: '工业级金属3D打印产业服务引领者',
    slogan: '专注于装备 - 材料 - 工艺 - 结构功能一体化创新设计与高质量制造',
    exploreEquip: '探索设备',
    contactUs: '联系我们',
    coreAdvantages: '核心优势',
    advantagesSub: 'SLM技术与AI智能制造驱动的数据化成果',
    whyChoose: '为什么选择创瑞',
    darkFactory: '自动化黑灯工厂',
    darkFactoryDesc: '无人化智能产线，24小时不间断生产，从粉末到零件全流程自动化',
    timeSaved: '制造周期缩短',
    timeSavedValue: '70%',
    timeSavedDesc: '无需模具开模，直接打印成品，从设计到交付效率提升数倍',
    materialSaved: '材料利用率',
    materialSavedValue: '>95%',
    materialSavedDesc: '增材制造净成形，对比传统切削加工仅10%-40%的材料利用率',
    precision: '成形精度',
    precisionValue: '±0.05mm',
    precisionDesc: '金属打印精度达微米级，纹理分辨率0.01mm，表面质量优异',
    autoDark: '黑灯智造',
    autoDarkValue: '24/7',
    autoDarkDesc: '全流程自动化无人值守，远程监控，智能排产，极致降本增效',
    equipmentLineup: 'SLM增材设备阵容',
    equipmentSub: '金属粉末床熔融打印 — 可定制成型尺寸从100mm至1500mm',
    viewAllEquip: '查看全部SLM增材设备 →',
    applicationProducts: '应用产品',
    productsSub: '覆盖多行业的专业3D打印解决方案',
    viewAllProd: '查看全部产品 →',
    globalFootprint: '全球制造布局',
    footprintSub: '多个生产基地，总车间面积40,000平方米',
    m2: 'm² 车间面积',
    bases: '生产基地',
    certs: '体系认证',
    learnFactory: '了解我们的工厂 →',
    together: '携手同路，共赢未来',
    togetherSub: '我们坚信，合作不是单方索取，而是价值共创',
  },
  about: {
    title: '关于我们',
    subtitle: '引领工业级金属增材制造的未来',


    companyIntro: `山东创瑞激光科技有限公司是一家专注于高端3D打印设备、3D打印精密结构件、激光增材制造解决方案及配套智能系统的高新技术企业。

自2016年成立以来，公司致力于增材制造领域的自主研发、复杂结构件制造、软件开发和技术创新。凭借专业的研发团队、严格的质量控制体系和标准化的生产基地，我们为工业制造、航空航天、汽车、医疗、模具和教育等高端行业的全球客户提供高性能、高稳定性、高可靠性的3D打印设备、定制化智能解决方案、柔性生产线和无人化工厂方案。

公司核心产品涵盖成型尺寸100mm至1500mm的金属粉末床熔融打印设备、各规格金属3D打印零件及3D打印软件。所有产品均符合质量标准，已获得权威认证，确保卓越性能与长久使用寿命。

山东创瑞激光是您在智能制造与先进增材制造解决方案领域的可靠合作伙伴，我们诚挚欢迎全球客户携手合作，共创美好未来。`,
    partnerMsg: '山东创瑞激光是您在智能制造与先进增材制造解决方案领域的可靠合作伙伴。我们诚挚欢迎全球客户携手合作，共创美好未来。',
    statsYears: '始于2016',
    statsLabel1: '创新历程',
    statsRange: '100–1500mm',
    statsLabel2: '成型尺寸范围',
    statsCert: 'ISO / CE',
    statsLabel3: '权威认证',
    statsGlobal: '全球',
    statsLabel4: '服务网络',
    timeline: '发展历程 · 积淀·跨越·致远',
    timelineSub: '每一个里程碑都蕴含着汗水的凝结，我们从初创走向壮大。稳扎稳打，持续突破，历履更迭初心，未来更将不负时代托付，与伙伴共赴巅峰。',
    sending: '发送中...',
    sendSuccess: '消息发送成功！我们会尽快与您联系。',
    sendError: '发送失败，请直接发送邮件与我们联系。',
  },
  equipments: {
    title: 'SLM增材制造设备',
    subtitle: '金属粉末床熔融打印 — 可定制成型尺寸从100mm至1500mm，支持非标定制',
    requestQuote: '获取报价',
    backToList: '← 返回设备列表',
    notFound: '设备未找到',
    specs: {
      title: '技术参数',
      buildSize: '成型尺寸',
      laser: '激光系统',
      materials: '可成型材料',
      accuracy: '成形精度',
      efficiency: '成形效率',
      feedMethod: '送粉方式',
      spreadMethod: '铺粉方式',
      protectGas: '保护气体',
      layerThickness: '分层厚度',
      oxygenContent: '工作氧含量',
      spotDiameter: '光斑直径',
      partRemoval: '取件方式',
      scanSystem: '扫描系统',
      machineSize: '设备尺寸',
      weight: '设备重量',
      scanSpeed: '扫描速度',
      powerConsumption: '设备功耗',
      basePlatePreheat: '基板预热',
      dataFormat: '数据格式',
      software: '配套软件',
      note: '注：①不含基板高度；②与零件尺寸、形状、激光功率，工艺参数有关；③为理论数据，实际尺寸受配置影响，以现场装机为准。\n※ 我公司保留更新及修改设备参数的权利，修改时恕不另行通知。',
      // W3500 等离子束电弧增材专属
      positioningAccuracy: '定位精度',
      wireFeedRate: '送丝速度',
      wireHeadCount: '连丝头数',
      formingSpeed: '成形速度',
    },
    applications: '应用领域',
    appPhotoPlaceholder: '应用照片',
    advantages: '设备优势',
    advantageItems: [
      '材料浪费率低于6%',
      '生产周期平均缩短70%',
      'AI辅助设计，精度、轻量化等性能大幅提升',
      '减少人力、材料和设计成本，降本40%以上',
      '智能化、数字化制造方式，质量有效控制',
      '米级大尺寸复杂结构定制化一体成型',
    ],
  },
  products: {
    title: '应用产品中心',
    subtitle: '覆盖多行业的专业3D打印解决方案',
    customSolution: '需要定制方案？',
    customDesc: '联系我们讨论您的具体3D打印需求',
    getInTouch: '联系我们',
  },
  factory: {
    title: '工厂与资质',
    subtitle: '40,000m²车间面积 — 大规模标准化生产能力',
    ourBases: '我们的基地',
    basesSub: '匠心力作，奔赴四方',
    facilities: '工厂设施',
    facilitiesSub: '生产车间、研发中心、检测设备和办公楼',
    certifications: '资质认证',
    certsSub: '权威认证，确保卓越性能和长久使用寿命',
    workshop: '生产车间',
    rdCenter: '研发中心',
    testLab: '检测实验室',
    office: '办公楼',
  },
  projects: {
    title: '案例展示',
    subtitle: '探索我们前沿的3D打印应用与解决方案',
    rdAnimations: '研发动画',
    animationsDesc: '3D打印技术与工艺的可视化展示',
    animPlaceholder: '3D打印过程动画',
    interested: '有兴趣合作？',
    interestedDesc: '联系我们讨论您的项目需求',
  },
  news: {
    title: '新闻动态',
    subtitle: '创瑞激光最新资讯',
    tctTitle: 'TCT亚洲展',
    tctDesc: '创瑞激光连续多年参展TCT亚洲展（上海国家会展中心），展示从单机设备到自动化产线的金属3D打印全场景解决方案，涵盖鞋模、轮胎模具、航空航天及新能源汽车等应用领域。',
    tctNote: '欢迎莅临创瑞激光展位，体验前沿增材制造技术。',
    exhibition: '展会',
    product: '产品',
    empty: '暂无新闻资讯，敬请期待。',
  },
  contact: {
    title: '联系我们',
    subtitle: '您可靠的智能制造合作伙伴 — 期待您的来信',
    getInTouch: '取得联系',
    contactIntro: '我们诚挚欢迎全球客户携手合作，共创美好未来。',
    phone: '电话',
    email: '邮箱',
    wechat: '微信',
    whatsapp: 'WhatsApp',
    wechatOfficial: '微信公众号',
    address: '地址',
    toBeUpdated: '待更新',
    sendMessage: '给我们留言',
    name: '姓名 *',
    namePlaceholder: '您的姓名',
    emailField: '邮箱 *',
    emailPlaceholder: 'your-email-address',
    company: '公司',
    companyPlaceholder: '您的公司名称',
    subject: '主题',
    selectSubject: '选择主题',
    equipment: '设备咨询',
    productInquiry: '产品/应用咨询',
    cooperation: '商务合作',
    other: '其他',
    message: '留言 *',
    messagePlaceholder: '请描述您的需求...',
    send: '发送消息',
    sent: '消息已发送！',
  },
  common: {
    loading: '加载中...',
    learnMore: '了解更多 →',
    viewAll: '查看全部 →',
    back: '← 返回',
    stainlessSteel: '不锈钢',
    toolSteel: '模具钢',
    aluminumAlloy: '铝合金',
    titaniumAlloy: '钛合金',
    nickelAlloy: '镍基合金',
    copperAlloy: '铜合金',
    pureCopper: '纯铜',
    superalloy: '高温合金',
  },
  // Equipment descriptions in Chinese
  equipDesc: {
    s100: '紧凑型金属3D打印机，适用于精密小零件制造。支持非标定制。',
    s130: '多功能金属3D打印机，适用于中小型精密零件。支持非标定制。',
    s180: '中型金属3D打印机，涵盖S100/S130规格，可定制100×100×100mm 500W×1 或 130×130×100mm 500W×1 成型尺寸。支持非标定制。',
    s250: '工业级金属3D打印机，适用于中型精密零件。支持非标定制。',
    s350: 'CR-S350是公司自主研发的中小尺寸绿光金属3D打印系列设备，能够满足高反射金属如纯金、纯铜、铜合金等材料，亚毫米级极限薄壁、复杂三维随形流道的一体化成型需求。标配1激光，选配2激光。成形尺寸250×250×350mm。',
    s420: 'CR-S420是公司自主研发的中尺寸金属3D打印系列设备，能够满足轮胎模具、工业制造等领域制造需求。该设备标配3激光，选配4激光，成形材料有铝合金、钛合金、镍基高温合金、钴铬合金、不锈钢、模具钢等，成形尺寸420×300×400mm。',
    s460: 'CR-S460是为了满足无人机装备、机器人部件以及机械制造领域，结构功能一体化，高精度、轻量化快速制造需求，自主研发的大中尺寸金属3D打印设备。标配4激光，选配6激光，成形材料有铝合金、钛合金、镍基高温合金、钴铬合金、不锈钢、模具钢等，成形尺寸460×460×500mm。',
    m460: 'CR-M460是公司自主研发的工业级六激光鞋模专用定制机型。成熟的调试技术、高质量的激光光束、超高的重复定位精度，保证长时间稳定运行的同时激光定位精度不发生偏移，完美解决了传统鞋模制造工艺流程复杂的问题，适应多元化生产场景需求，可实现高效率、高强度、高质量、持续性生产。标配6激光，成形尺寸460×430×150mm。',
    m600: 'CR-M600是公司自主研发的第二代鞋模专用定制机型，激光数量升级为8束，继承第一代鞋模专机稳定的打印质量和工艺数据的基础上，极大的提升了打印速度。成形材料有铝合金、钛合金、镍基高温合金、钴铬合金、不锈钢、模具钢等，成形尺寸600×450×200mm。',
    s610: 'CR-S610是公司自主研发的大尺寸金属3D打印系列设备，旨在满足航空航天、核能装备以及海工船舶等领域，复杂内流道结构、悬垂结构、复杂型面薄壁结构以及闭式叶轮结构等超大尺寸零件快速制造需求。该设备标配6激光，选配4激光，成形材料有铝合金、钛合金、镍基高温合金、钴铬合金、不锈钢、模具钢等，成形尺寸610×610×800mm。',
    s650: 'CR-S650是公司自主研发的超大尺寸金属3D打印系列设备，旨在满足大型无人机等低空经济领域，高大尺寸零件快速制造需求。该设备标配6激光，成形材料有铝合金、钛合金、镍基高温合金、钴铬合金、不锈钢、模具钢等，成形尺寸650×650×1000mm。',
    s850: 'CR-S850是公司自主研发的超大尺寸金属3D打印系列设备，旨在满足航空、航天件扩张段、尾喷管、燃烧室等超高尺寸零件快速制造需求。该设备标配8激光，成形材料有铝合金、钛合金、镍基高温合金、钴铬合金、不锈钢、模具钢等，成形尺寸850×850×1500mm。',
    s1300: 'CR-S1300是公司自主研发的超大尺寸金属3D打印系列装备，满足航空航天、风能核电等领域，特大尺寸工业零部件快速制造需求。设备标配12激光，选配16激光，成形材料有铝合金、钛合金、镍基高温合金、不锈钢、模具钢等，成形尺寸1250×1250×1500mm。',
    s1500: 'CR-S1500是公司自主研发的超大尺寸金属3D打印系列设备，旨在满足航天航空、海工船舶、核能核电等领域，米级超大尺寸零部件快速制造需求。该设备标配16激光，选配22激光，成形材料有铝合金、钛合金、镍基高温合金、钴铬合金、不锈钢、模具钢等，成形尺寸1500×1500×1500mm。',
    s2500: 'CR-S2500是公司自主研发的超大尺寸金属3D打印系列装备，满足航空航天、工业能源以及海工核电领域，超大尺寸零部件一体化制造需求。设备标配36激光，选配64激光，成形材料有铝合金、钛合金、镍基高温合金、不锈钢、模具钢等，成形尺寸2500×2500×2500mm。',
    w3500: 'CR-W3500是公司与北京理工大学联合研发的等离子束智能增材制造装备。该装备能够满足高超音速飞行器栅格舵和航空中大型无人机机翼等复杂构件对高性能、高效率、低成本增材制造需求。成形材料有不锈钢、钛合金、铝合金、高熵合金等，成形尺寸3500×1500×800mm，支持按需定制。',
  },
  // Product descriptions in Chinese
  prodDesc: {
    medical: '我们的增材制造装备可以实现1类至3类医疗植入产品的激光3D打印制造，如钛合金牙冠、口腔支架、髋臼杯植入物、脊柱植入物等。',
    education: '我们的3D打印设备作为高校和职业院校的核心科研与教学设备，广泛应用于材料学院材料分析与科研、STEAM创新设计、建模设计及智能机器人部件、文创产品等3D打印创意产品开发。同时辅助工业设计、机械、艺术、建筑、医学等专业学生的毕业设计制作与实物展示，并广泛用于模具制造、数控、智能制造等专业的实训教学与技能训练。',
    shoeMold: '金属 3D 打印鞋底模具采用 SLM 选择性激光熔化技术，直接成型模具钢材质的鞋底模腔，可实现复杂花纹、精细纹理与一体化随形冷却水道的一体化制造。相比传统机加工模具，成型精度更高、细节还原更细腻，冷却效率大幅提升，显著缩短注塑与发泡周期，提高鞋底量产稳定性与良品率。特别适用于高端运动鞋底、休闲鞋底、防滑纹理及复杂结构模具的快速开发与小批量定制，帮助鞋类企业缩短研发周期、降低改模成本，提升产品竞争力。',
    injectionMold: '3D 金属打印注塑模具与压铸模具采用 SLM 选择性激光熔化技术，使用模具钢、铜合金等高性能材料直接成形，可实现传统工艺难以加工的随形冷却水路、复杂型腔与精细纹理结构。相较于传统模具，其冷却效率更高，能显著缩短注塑、压铸成型周期，减少产品变形与缩痕，提升良品率与生产稳定性，同时大幅压缩开发交付周期。广泛应用于汽车、消费电子、医疗、包装、日用品等行业，为复杂结构、快速迭代及小批量高效生产提供高性能、高柔性的先进模具解决方案。',
    precisionParts: '3D 打印精密结构件依托 SLM 金属打印技术，可实现复杂内腔、点阵轻量化、异形流道及一体化集成结构的高精度成型，突破传统加工限制。产品尺寸精度高、表面质量优异、力学性能稳定，适用于对结构复杂度、轻量化与可靠性要求严苛的场景，广泛应用于航空航天、汽车、医疗器械、精密机械及高端装备领域，为复杂零件快速研发与小批量定制提供高效解决方案。',
  },
  // Advantages in Chinese
  advTitle: {
    manufacturingCycle: '制造周期',
    materialUtilization: '材料利用率',
    weightReduction: '零件减重',
    complexStructures: '复杂结构',
    partIntegration: '一体化集成',
    precision: '精度',
    density: '致密度',
    rdIteration: '研发迭代',
  },
  advDesc: {
    manufacturingCycle: '制造周期平均缩短（无需模具、减少工序）',
    materialUtilization: '对比传统切削利用率仅10%–40%',
    weightReduction: '通过点阵/拓扑优化实现',
    complexStructures: '随形冷却流道最小内径',
    partIntegration: '将多个零件合并为单件，减少装配点',
    precision: '金属打印精度达，纹理分辨率0.01mm',
    density: '打印态致密度；热处理后力学性能近似锻件标准',
    rdIteration: '设计变更到新样件；结合AI生成式设计再缩短70%',
  },
  // Factory bases in Chinese
  bases: {
    yantai: { name: '烟台总部', role: '管理、资本、材料研发中心' },
    xian: { name: '西安基地', role: '技术、装备、核心部件高地' },
    fujian: { name: '福建基地', role: '应用、服务、市场孵化前沿' },
  },
  // Service industries (aligned with application products)
  serviceIndustries: [
    '医疗 / 齿科',
    '教育 / 科研',
    '鞋底模具',
    '注塑模具 / 压铸模具',
    '精密结构件',
  ],
  // Applications in Chinese (for Home page quick links)
  applications: [
    '航空航天', '海工船舶', '核能核电',
    '无人机', '机器人', '3C电子',
    '轮胎模具', '金属鞋模', '军事工业',
    '卫星', '纺织机械',
  ],
  // Partners
  partners: ['弘晟精密模具', '福建兴迅新材料'],
  // Company info in Chinese
  company: {
    fullName: '山东创瑞激光科技有限公司',
    address: '中国山东省烟台市 & 陕西省西安市',
  },

  factoryDesc: '我司拥有分别位于陕西省西安市和山东省烟台市的两个生产基地，总车间面积达40,000平方米。配备先进的精密检测设备，建立了完善的生产和质量控制体系，具备大规模、标准化、高质量的3D打印设备和零部件生产交付能力。',
}
